<!-- 广告查询 -->
<template>
    <div class="page-form" >
        <Breadcrumb :title="title" />
        <div class="detail-wrap"> 
            <el-tabs  v-model="activeName" @tab-click="changeTabs"  type="card">
                <el-tab-pane   ane label="网页广告" name="a" >  
                    <el-table border :data="tableData" style="width: 100%;" v-loading="loading">
                        <el-table-column  type="index" width="100" align="center"/>
                        <el-table-column   label="广告图片" >
                            <template slot-scope="scope">
                                <img :src="scope.row.imageUrl" alt="" width="300px">
                            </template>
                        </el-table-column>
                        <el-table-column  fixed="right" label="操作"  width="180">
                            <template slot-scope="scope">                       
                                <el-button @click="handleUpdate(scope.row,'a')" type="text" icon="el-icon-edit" size="small">编辑</el-button>
                                <el-button @click="handleDelete(scope.row,50)" type="text" icon="el-icon-delete" size="small">删除</el-button>
                            </template>                   
                        </el-table-column>
                    </el-table>
                    <pagination
                        style="text-align:right"
                        v-show="total > 10"
                        :total="total"
                        :page.sync="queryParams.page"
                        :limit.sync="queryParams.pagesize"
                        @pagination="getAdvertPC"
                    />
                </el-tab-pane>
                <el-tab-pane label="小程序广告" name="b" > 
                    <el-table border :data="tableData2" style="width: 100%;" v-loading="loading">
                        <el-table-column  type="index" width="100" align="center"/>
                        <el-table-column   label="广告图片" >
                            <template slot-scope="scope">
                                <img :src="scope.row.imageUrl" alt="" width="300px">
                            </template>
                        </el-table-column>
                        <el-table-column  fixed="right" label="操作"  width="180">
                            <template slot-scope="scope">                       
                                <el-button @click="handleUpdate(scope.row,'b')" type="text" icon="el-icon-edit" size="small">编辑</el-button>
                                <el-button @click="handleDelete(scope.row,51)" type="text" icon="el-icon-delete" size="small">删除</el-button>
                            </template>                   
                        </el-table-column>
                    </el-table>
                    <pagination
                        style="text-align:right"
                        v-show="total > 10"
                        :total="total"
                        :page.sync="queryParams.page"
                        :limit.sync="queryParams.pagesize"
                        @pagination="getAdvertWX"
                    />
                </el-tab-pane>
            </el-tabs>           
        </div>
    </div>
</template>

<script>
import pagination  from '@/components/Pagination'
import Breadcrumb from '@/components/Breadcrumb'
export default {
    components:{
        pagination,
        Breadcrumb
    },
    data() {
        return {
            loading: false,
            searchForm:{
                dateRange: [],
            },
            startDate: 0,
            endDate: 0,
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            tableData2: [],
            total: 0,
            activeName: 'a'
        }   
    },
    created() {
        this.getAdvertPC()
        this.getAdvertWX()
    },
    mounted() {
        
    },
    computed:{
        title(){
            return this.$route.meta.title
        }    
    },
    methods: {
        getAdvertPC(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 50  
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        this.tableData = result.map(item=>{
                            return{
                                imageUrl: item['中文描述'],
                                value:  item['中文描述'],
                                id: item['词条索引'],
                            }
                        })   
                    }     
                }
            })
        },
        getAdvertWX(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 51  
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        this.tableData2 = result.map(item=>{
                            return{
                                imageUrl: item['中文描述'],
                                value:  item['中文描述'],
                                id: item['词条索引'],
                            }
                        })   
                    }     
                }
            })
        },
        handleDelete(row,no){
            this.$confirm('确定删除这条广告吗?','提示').then(()=>{
            this.deleteConfirm(row,no)
            }).catch(err=>{
                console.log(err)
            })
        },
        deleteConfirm(row,no){
            let params = {
                opcode: this.$code.PubAdvert,
                i_no: no,
                v_name: row.id,
                v_caption: row.value,
                flag: 3            
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success(res.Message)
                    if(no === 50){
                        this.getAdvertPC()
                    }else{
                        this.getAdvertWX()
                    }
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        handleUpdate(row,type){
            this.$router.push({
                path: 'advert',
                query: {
                    id: row.id,
                    type: type
                }
            })
        }, 
        changeTabs(){

        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.detail-wrap {
    width: 750px;
    padding: 30px 60px;
    font-size: 16px;
    line-height: 28px;
}
</style>


// WEBPACK FOOTER //
// src/views/news/advertQuery.vue